import React from "react";
import "../../styles/aboutUs.css"; 

const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        
        {/* LEFT SIDE: IMAGE */}
        <div className="about-image-side">
          <img 
            src="https://i.pinimg.com/736x/d9/1a/c7/d91ac7655b427193f8c29d2fd4e9b191.jpg" 
            alt="ERP Training Session" 
            className="about-img"
          />
        </div>

        {/* RIGHT SIDE: TEXT */}
        <div className="about-text-side">
          <h2 className="about-title">ERP Training</h2>
          
          <p className="about-description">
            Master the Tools of Modern Business.
          </p>
          
          <p className="about-sub-description mb-4">
            ERP (Enterprise Resource Planning) systems are at the heart of today's businesses. 
            Our ERP program trains you on industry-leading platforms to streamline business 
            operations and make you a valuable asset to any organization.
          </p>

          <h4 className="fw-bold text-dark mb-3">You Will Learn:</h4>

          {/* FEATURE LIST */}
          <div className="about-features">
            
            {/* Item 1 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i> 
              </div>
              <span className="feature-text">
                <strong>Tally Prime for Accounting & GST</strong>
              </span>
            </div>

            {/* Item 2 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Zoho Books & QuickBooks for Cloud Accounting</strong>
              </span>
            </div>

            {/* Item 3 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Inventory, Payroll, and Compliance Modules</strong>
              </span>
            </div>

            {/* Item 4 */}
            <div className="feature-item">
              <div className="icon-circle">
                <i className="bi bi-book"></i>
              </div>
              <span className="feature-text">
                <strong>Hands-on practice with real-world business scenarios</strong>
              </span>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;